import { useMemo, useState } from 'react';
import { useAtomValue } from 'jotai';
import { selectedTemplateField as selectedAssemblyField } from '../state';
import { PageLoader } from '../../shared/PageLoader';
import { assemblyTabStyles, FloatingLine } from './styles';
import { BasicTabs } from '@/components/shared/BasicTabs';
import { AssemblyFieldsPanel } from './AssemblyFieldsPanel';
import { ReviewPanelConfigForm } from './ReviewPanelConfigForm';

export const AssemblyTemplateForm = ({
  emptyForm,
  handleEmptyForm,
  structureId,
}: {
  emptyForm: boolean;
  handleEmptyForm: (value: boolean) => void;
  structureId: string;
}) => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const selectedField = useAtomValue(selectedAssemblyField);

  const handleTabChange = (selectedTabIndex: number) => {
    setSelectedTab(selectedTabIndex);
  };

  const tabs = useMemo(() => {
    return [
      {
        index: 0,
        label: 'Fields',
        component: (
          <AssemblyFieldsPanel
            emptyForm={emptyForm}
            handleEmptyForm={handleEmptyForm}
            structureId={structureId}
          />
        ),
      },
      {
        index: 1,
        label: 'Review Panel Configuration',
        component: <ReviewPanelConfigForm structureId={structureId} />,
      },
    ];
  }, [emptyForm, handleEmptyForm, structureId]);

  if (!selectedField) return <PageLoader />;

  return (
    <>
      <BasicTabs
        tabs={tabs}
        selectedTab={selectedTab}
        changeTab={handleTabChange}
        tabsStyles={assemblyTabStyles}
        customSeperator={<FloatingLine />}
        renderingStrategy="eager"
      />
    </>
  );
};
